<template>
  <div class="alert-comment" :class="{ deleting: deleting }">
    <div class="tools">
      <font-awesome-icon class="tools-btn" icon="trash" @click="deleteComment" title="Delete comment"/>
      <font-awesome-icon class="tools-btn" icon="edit" @click="editComment" title="Edit comment" v-show="!editing"/>
      <font-awesome-icon class="tools-btn" icon="save" @click="saveComment" title="Save comment" v-show="editing"/>
    </div>

    <div class="header">
      <div class="nick" v-show="!editing">{{ comment.nick }}</div>
      <div class="nick" v-show="editing">
        <input v-model="comment.nick">
      </div>
      <div class="timestamp">{{ comment.created }}</div>
    </div>

    <div class="text" v-show="!editing" v-html="commentText"></div>
    <textarea class="text" v-model="comment.text" v-show="editing" rows="5"/>
  </div>
</template>

<style scoped>
.alert-comment {
  /*border: 1px solid #cccccc;*/
  border-radius: 3px;
  background-color: #eee;
  padding: 3px;
  margin-top: 3px;
  margin-bottom: 3px;
}
.timestamp {
  display: inline-block;
  font-size: 12px;
  color: #aaa;
}
.nick {
  display: inline-block;
  font-size: 14px;
  color: #666;
  margin-right: 5px;
}
.text {
  width: 99%;
  font-size: 14px;
}
.tools {
  float: right;
  font-size: 0.9em;
}
.tools-btn {
  float: right;
  color: #666;
  margin: 3px;
  cursor: pointer;
}
.tools-btn:hover {
  color: #333;
}
.deleting {
  opacity: 0.5;
}
</style>

<script>
export default {
  name: 'AlertComment',
  props: {
    comment: {
      type: Object,
      required: true
    }
  },
  computed: {
    commentText () {
      var text = this.comment.text
      text = text.replace(/(&)/g, '&amp;')
      text = text.replace(/(<)/g, '&lt;')
      text = text.replace(/(>)/g, '&gt;')
      text = text.replace(/(?:\r\n|\r|\n)/g, '<br/>')
      return text
    }
  },
  methods: {
    editComment () {
      // console.log('Edit comment')
      this.editing = true
    },
    saveComment () {
      // console.log('Save comment')
      this.editing = false
      if (this.comment.creating) {
        this.comment.creating = false
        this.$emit('create')
      } else {
        this.$emit('update')
      }
    },
    deleteComment () {
      // console.log('Delete comment')
      if (!confirm('Are you sure? This will delete the comment!')) return
      this.deleting = true
      this.$emit('delete')
    }
  },
  data () {
    return {
      editing: false,
      deleting: false,
      rows: 5,
    }
  },
  mounted () {
    if (this.comment.creating) this.editing = true
  }
}
</script>
